import { styled } from 'styled-components';
import { useState } from 'react';

import { Tabs, Tab, VStack } from '@vivaahealth/design-system';

export enum Selected {
  About = 'About',
  Insurances = 'Insurances',
  Locations = 'Locations',
  Publications = 'Publications',
  Reviews = 'Reviews',
}

interface Props {
  hasSection: {
    about: boolean;
    reviews: boolean;
    insurances: boolean;
    publications: boolean;
  };
  handleSelect: (eventKey: Selected) => void;
}

const StickyTabs: React.FC<Props> = ({ hasSection, handleSelect }) => {
  const [tab, setTab] = useState(0);
  const tabs = [
    {
      hasSection: hasSection.about,
      label: 'About',
    },
    {
      hasSection: true,
      label: 'Locations',
    },
    {
      hasSection: hasSection.reviews,
      label: 'Reviews',
    },
    {
      hasSection: hasSection.insurances,
      label: 'Insurances',
    },
    {
      hasSection: hasSection.publications,
      label: 'Publications',
    },
  ];

  return (
    <TabContainer>
      <UnderlinedTabs
        value={tab}
        onChange={(_, newValue) => {
          handleSelect(tabs[newValue].label as Selected);
          setTab(newValue);
        }}
      >
        {tabs.map(
          ({ hasSection, label }, idx) =>
            hasSection && <StyledTab key={idx} label={label} />,
        )}
      </UnderlinedTabs>
    </TabContainer>
  );
};

export default StickyTabs;

const TabContainer = styled(VStack)`
  @media (max-width: 767px) {
    display: none;
  }
  padding: 0;
  margin-bottom: 24px;
`;

const UnderlinedTabs = styled(Tabs)`
  box-shadow: inset 0 -2px 0 #d9d9d9;
`;

const StyledTab = styled(Tab)`
  text-transform: none;
  padding: 10px 8px;
`;
